/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-danger */
import { useState, useEffect } from "react";
import { ContactSchema } from "constants/index";
import { FormContact } from "components/User";
import { formatSchemaContact } from "helpers";

import ModalMaterialUi from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import styled from "styled-components";

import { useGlobalContext } from "context/GlobalContext";

const Modal = styled(ModalMaterialUi)`
  display: flex;
  align-items: center;
  justify-content: center;

  .body {
    border: 2px solid #ddd;
    padding: 16px 32px 24px;
    box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
      0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%);
    background-color: #fff;

    width: 100vw;
    height: 100vh;
    overflow: scroll;
    max-width: 480px;
    max-height: 480px;
    border-radius: 8px;
  }
`;

export const ModalContact = () => {
  const [isUpdate, setIsUpdate] = useState(false);
  const [state, setState] = useState(ContactSchema);
  const gContext = useGlobalContext();

  useEffect(() => {
    if (!gContext.contact) {
      setState(ContactSchema);
      setIsUpdate(false);
    } else {
      const data = formatSchemaContact(gContext.contact);
      setState(data);
      setIsUpdate(true);
    }
  }, [gContext.contactModalVisible]);

  if (!gContext.contactModalVisible) {
    return null;
  }

  return (
    <Modal
      title="Contacto de emergencia"
      open={gContext.contactModalVisible}
      onClose={() => gContext.toggleContactModal(null)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={gContext.contactModalVisible}>
        <div className="body">
          <h2 className="tl pl1">Contacto de emergencia</h2>
          <FormContact
            data={state}
            isUpdate={isUpdate}
            isCompleteForm={false}
          />
        </div>
      </Fade>
    </Modal>
  );
};
